import React, { useState } from 'react';
import Footer from "../../../Footer/Footer";
import NavBar from "../../../Navbar/NavBar";
import { Form, Segment, Button, TextArea } from 'semantic-ui-react';
import { BrowserView, MobileView } from 'react-device-detect';
import { FormEnviaDadosLuminariasAction } from '../../../../actions/FormActions';
import { connect } from 'react-redux';
import ModalLoading from './ModalLoading';
import DropzoneComponent from '../formularios/Dropzone'
import { useNavigate } from 'react-router';
import { ToastContainer, toast } from 'react-toastify';



function FormEspacoLux(props) {

    const { FormEnviaDadosLuminariasAction } = props;
    const { form_info, loading_form_dados } = props;

    let telefone = form_info?.telefone?.replace(/\s+/g, '');
    let fax = form_info?.fax?.replace(/\s+/g, '');

    const nomeConsumidor = form_info.nomeparc;
    const enderecoConsumidor = form_info.endereco;
    const bairroConsumidor = form_info.bairro;
    const cidadeConsumidor = form_info.cidade;
    const foneConsumidor = telefone?.length === 0 ? (fax?.length === 0 ? '' : fax) : telefone;
    const emailConsumidor = form_info.email;
    const cpfConsumidor = form_info.cgc_cpf;
    const nomeprod = form_info.desc_prod;

    const [formValues, setFormValues] = useState({
        observacoes: '',
    });

    const [errors, setErrors] = useState({});
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [fileError, setFileError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isChecked, setIsChecked] = useState(false);

    const navigate = useNavigate();

    const handleChange = (e, { name, value }) => {
        setFormValues({ ...formValues, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Se já estiver submetendo, não faça nada
        if (isSubmitting) {
            return;
        }



        let validationErrors = {};

        if (uploadedFiles.length === 0) {
            validationErrors.uploadedFiles = true;
        }

        if (!formValues.observacoes) {
            validationErrors.observacoes = true;
        }

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
        } else {

            setIsSubmitting(true);
            FormEnviaDadosLuminariasAction(form_info, formValues.observacoes, uploadedFiles)
                .then(() => {
                    setIsChecked(true);

                    setTimeout(() => {
                        navigate('/assistencia/protocolo');
                        setIsSubmitting(false);
                    }, 4000); toast.success(
                        <div>
                            <p style={{ margin: 0 }}><b>Sucesso!</b></p>
                            <small><b>Form enviado com sucesso</b></small><br></br>
                            <small style={{ margin: 0 }}>Clique aqui para fechar.</small>
                        </div>,
                        {
                            position: "top-right",
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            draggable: true,
                            progress: undefined,
                            style: {
                                background: "#fff",
                                color: "#000",
                            },
                        }
                    );
                })
                .catch((error) => {
                    console.error(error);

                    setIsSubmitting(false);
                    setIsChecked(false);

                    toast.error(
                        <div>
                            <p style={{ margin: 0 }}><b>Erro ao enviar</b></p>
                            <small>Não foi possível concluir o envio. Tente novamente.</small>
                        </div>
                    );
                });
        }
    };

    return (
        <>
            <BrowserView>
                <div id="topo" />
                <NavBar />
                <Form onSubmit={handleSubmit}>
                    <Segment><ToastContainer />
                        <h3>Assistência EspaçoLux</h3>
                        <hr></hr>
                        <p style={{ fontSize: '24px' }}>{nomeprod}</p>
                        <Form.Group widths='equal'>
                            <Form.Field>
                                <label>Nome</label>
                                <Form.Field
                                    fluid="true"
                                    placeholder='Nome'
                                    name='nome'
                                    label={nomeConsumidor}
                                    readOnly
                                />
                            </Form.Field>
                            <Form.Field>
                                <label>Telefone</label>
                                <Form.Field
                                    fluid="true"
                                    placeholder='Telefone'
                                    name='telefone'
                                    label={foneConsumidor}
                                    readOnly
                                />
                            </Form.Field>
                            <Form.Field>
                                <label>Email</label>
                                <Form.Field
                                    fluid="true"
                                    placeholder='Email'
                                    name='email'
                                    label={emailConsumidor}
                                    readOnly
                                />
                            </Form.Field>
                            <Form.Field>
                                <label>CPF</label>
                                <Form.Field
                                    fluid="true"
                                    placeholder='CPF'
                                    name='cpf'
                                    label={cpfConsumidor}
                                    readOnly
                                />
                            </Form.Field>
                        </Form.Group>
                        <Form.Group widths='equal'>
                            <Form.Field>
                                <label>Endereço</label>
                                <Form.Field
                                    fluid="true"
                                    placeholder='Endereço'
                                    name='endereco'
                                    label={enderecoConsumidor}
                                    readOnly
                                />
                            </Form.Field>
                            <Form.Field>
                                <label>Bairro</label>
                                <Form.Field
                                    fluid="true"
                                    placeholder='Bairro'
                                    name='bairro'
                                    label={bairroConsumidor}
                                    readOnly
                                />
                            </Form.Field>
                            <Form.Field>
                                <label>Cidade</label>
                                <Form.Field
                                    fluid="true"
                                    placeholder='Cidade'
                                    name='cidade'
                                    label={cidadeConsumidor}
                                    readOnly
                                />
                            </Form.Field>
                        </Form.Group>
                        <Form.Field error={!!(errors.uploadedFiles || fileError)}>
                            <label>Upload de Imagem</label>
                            <DropzoneComponent
                                maxFiles={5}
                                maxSize={5 * 1024 * 1024} // 5MB
                                accept={{
                                    'image/png': ['.png'],
                                    'image/jpeg': ['.jpeg'],
                                    'image/jpg': ['.jpg'],
                                    'application/pdf': ['.pdf'],
                                    'video/mp4': ['.mp4'],
                                    'video/quicktime': ['.mov'],
                                    // Adicione outros formatos conforme necessário
                                }}
                                onFilesChange={(files) => {
                                    setUploadedFiles(files);
                                    if (files.length === 0) {
                                        setFileError('Por favor, adicione ao menos um arquivo.');
                                    } else {
                                        setFileError('');
                                    }
                                }}
                            />
                            {fileError && <p style={{ color: 'red' }}>{fileError}</p>}
                        </Form.Field>
                        <Form.Group widths='equal'>
                            <Form.Field error={errors.observacoes}>
                                <label>Descreva com detalhes o motivo da solicitação</label>
                                <TextArea
                                    placeholder='Descreva com detalhes o motivo da solicitação'
                                    name='observacoes'
                                    value={formValues.observacoes}
                                    onChange={handleChange}
                                    maxLength={3500}
                                />
                                <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-end', alignItems: 'center' }} className="text-left text-gray-500">
                                    {formValues.observacoes.length}/3500
                                </div>
                            </Form.Field>
                        </Form.Group>
                        <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-end', alignItems: 'center' }}>
                            <Button primary type='submit' style={{ marginBottom: '25px', width: '100%', margin: '5px' }} loading={loading_form_dados || isSubmitting}>
                                {loading_form_dados || isSubmitting ? (
                                    <div style={{ alignItems: 'center', justifyContent: 'center' }}>
                                        <ModalLoading
                                            sending={isSubmitting}
                                            checked={isChecked}
                                        />
                                    </div>
                                ) : (

                                    <div> Confirmar</div>
                                )}

                            </Button>
                        </div>
                    </Segment>


                </Form>
                <Footer />
            </BrowserView>

            <MobileView >
                <div id="topo" />
                <NavBar mobile />
                <Form onSubmit={handleSubmit}>
                    <Segment><ToastContainer />
                        <h3>Assistência EspaçoLux</h3>
                        <Form.Group widths='equal'>
                            <Form.Field>
                                <label>Nome</label>
                                <Form.Field
                                    fluid="true"
                                    placeholder='Nome'
                                    name='nome'
                                    label={nomeConsumidor}
                                    readOnly
                                />
                            </Form.Field>
                            <Form.Field>
                                <label>Telefone</label>
                                <Form.Field
                                    fluid="true"
                                    placeholder='Telefone'
                                    name='telefone'
                                    label={foneConsumidor}
                                    readOnly
                                />
                            </Form.Field>
                            <Form.Field>
                                <label>Email</label>
                                <Form.Field
                                    fluid="true"
                                    placeholder='Email'
                                    name='email'
                                    label={emailConsumidor}
                                    readOnly
                                />
                            </Form.Field>
                            <Form.Field>
                                <label>CPF</label>
                                <Form.Field
                                    fluid="true"
                                    placeholder='CPF'
                                    name='cpf'
                                    label={cpfConsumidor}
                                    readOnly
                                />
                            </Form.Field>
                        </Form.Group>
                        <Form.Group widths='equal'>
                            <Form.Field>
                                <label>Endereço</label>
                                <Form.Field
                                    fluid="true"
                                    placeholder='Endereço'
                                    name='endereco'
                                    label={enderecoConsumidor}
                                    readOnly
                                />
                            </Form.Field>
                            <Form.Field>
                                <label>Bairro</label>
                                <Form.Field
                                    fluid="true"
                                    placeholder='Bairro'
                                    name='bairro'
                                    label={bairroConsumidor}
                                    readOnly
                                />
                            </Form.Field>
                            <Form.Field>
                                <label>Cidade</label>
                                <Form.Field
                                    fluid="true"
                                    placeholder='Cidade'
                                    name='cidade'
                                    label={cidadeConsumidor}
                                    readOnly
                                />
                            </Form.Field>
                        </Form.Group>
                        <Form.Field error={!!(errors.uploadedFiles || fileError)}>
                            <label>Upload de Imagem</label>
                            <DropzoneComponent
                                maxFiles={5}
                                maxSize={5 * 1024 * 1024} // 5MB
                                accept={{
                                    'image/png': ['.png'],
                                    'image/jpeg': ['.jpeg'],
                                    'image/jpg': ['.jpg'],
                                    'application/pdf': ['.pdf'],
                                    'video/quicktime': ['.mov'],
                                    // Adicione outros formatos conforme necessário
                                }}
                                onFilesChange={(files) => {
                                    setUploadedFiles(files);
                                    if (files.length === 0) {
                                        setFileError('Por favor, adicione ao menos um arquivo.');
                                    } else {
                                        setFileError('');
                                    }
                                }}
                            />
                            {fileError && <p style={{ color: 'red' }}>{fileError}</p>}
                        </Form.Field>
                        <Form.Group widths='equal'>
                            <Form.Field error={errors.observacoes}>
                                <label>Descreva com detalhes o motivo da solicitação</label>
                                <TextArea
                                    placeholder='Descreva com detalhes o motivo da solicitação'
                                    name='observacoes'
                                    value={formValues.observacoes}
                                    onChange={handleChange}
                                    maxLength={3500}
                                />
                                <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-end', alignItems: 'center' }} className="text-left text-gray-500">
                                    {formValues.observacoes.length}/3500
                                </div>
                            </Form.Field>
                        </Form.Group>
                        <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-end', alignItems: 'center' }}>
                            <Button primary type='submit' style={{ marginBottom: '25px', width: '100%', margin: '5px' }} loading={loading_form_dados || isSubmitting}>
                                {loading_form_dados || isSubmitting ? (
                                    <div style={{ alignItems: 'center', justifyContent: 'center' }}>
                                        <ModalLoading
                                            sending={isSubmitting}
                                            checked={isChecked}
                                        // handleComplete={handleComplete}
                                        />
                                    </div>
                                ) : (

                                    <div> Confirmar</div>
                                )}

                            </Button>
                        </div>
                    </Segment>
                </Form>
                <Footer mobile />
            </MobileView>

        </>
    );
}

const mapStateToProps = state => ({
    form_info: state.FormReducer.form_info,
    form_padrao: state.ItensNotaReducer.form_padrao,
    loading_form_dados: state.FormReducer.loading_form_dados
});

export default connect(mapStateToProps, {
    FormEnviaDadosLuminariasAction,
})(FormEspacoLux);